'use strict';

angular.module('client.services').factory('ClassesGrades', ['$resource', 'api_server', function ($resource, api_server) {
  return $resource(api_server + '/classes/grades_list', {}, {get: {isArray: true, cache: true}});
}]);
